import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap'; // Import Spinner from react-bootstrap
import usePost from 'core/hooks/api/usePost';
import { API_ENDPOINTS } from 'core/constant/API_ENDPOINTS';
import { InputText, DropdownField, InputNumber } from 'components/common/input'; // Import custom input components
import { validateForm } from 'core/utils/validation'; // Import validation function
import useFormHandlers from 'core/hooks/form/useFormHandlers'; // Import useFormHandlers
import { Helmet } from 'react-helmet';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    user_type: '',
    state: '',
    phone: '',
    position: '',
    customPosition: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false); // State for loading spinner
  const [isSubmitting, setIsSubmitting] = useState(false); // State for loading spinner
  const { postData } = usePost(API_ENDPOINTS.CONTACT);
  const { handleChange } = useFormHandlers(setFormData);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Set loading state to true
    const validationRules = [
      { field: 'name', method: 'required' },
      { field: 'email', method: 'required' },
      { field: 'phone', method: ['required', 'validPeruPhone'] },
      { field: 'user_type', method: 'required' },
    ];
    const validationErrors = validateForm(formData, validationRules);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setIsSubmitting(false); // Set loading state to false
      return;
    }
    await postData({...formData, phone: String(formData.phone)});
    window.dataLayer.push({
      event: 'form_completed',
      form_id: 'contacto',
    });
    setFormSubmitted(true);
    setIsSubmitting(false); // Set loading state to false
  };

  let publicUrl = process.env.PUBLIC_URL+'/'

  return (
    <div className="ltn__contact-message-area mb-120 mb--100">
      <Helmet>
        <title>Contacta a Artectum | Cotiza Acabados para Construcción</title>
        <meta name="description" content="¿Necesitas baldosas, terrazos o mosaicos? Escríbenos por WhatsApp o deja tu consulta aquí. Te asesoramos en tu proyecto." />
      </Helmet>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="ltn__form-box contact-form-box box-shadow white-bg">
              <h4 className="title-2">Obtener una cotización</h4>
              {formSubmitted ? (
                <div id="contact-pro-forma" className="form-submitted-message">
                  <h5>Formulario enviado con éxito</h5>
                  <p>Gracias por contactarnos. Nos pondremos en contacto con usted pronto.</p>
                </div>
              ) : (
                <form id="form-pro-forma" action={publicUrl+"mail.php"} method="post" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <InputText name="name" placeholder="Ingrese su nombre completo" onChange={(e) => handleChange('name', e.target.value)} value={formData.name} label="Nombre Completo" error={errors.name} />
                    </div>
                    <div className="col-md-6">
                      <DropdownField
                        name="user_type"
                        options={[
                          { label: 'Empresa', value: 'company' },
                          { label: 'Persona', value: 'person' },
                          { label: 'Entidad Pública', value: 'publicEntity' }
                        ]}
                        onChange={(e) => handleChange('user_type', e.value)}
                        value={formData.user_type}
                        placeholder="Seleccione el tipo de servicio"
                        label="Tipo de Servicio"
                        error={errors.user_type}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputText name="email" placeholder="Ingrese su correo electrónico" onChange={(e) => handleChange('email', e.target.value)} value={formData.email} label="Correo Electrónico" error={errors.email} />
                    </div>
                    <div className="col-md-6">
                      <InputNumber name="phone" placeholder="Ingrese su número de teléfono" onChange={(e) => handleChange('phone', e.value)} value={formData.phone} label="Teléfono" error={errors.phone} />
                    </div>
                  </div>
                  <InputText name="message" placeholder="Ingrese su mensaje" onChange={(e) => handleChange('message', e.target.value)} value={formData.message} label="Mensaje" error={errors.message} />
                  <div className="btn-wrapper mt-0">
                    <button className="btn theme-btn-1 btn-effect-1 text-uppercase" type="submit" disabled={isSubmitting}>
                      {isSubmitting ? (
                        <>
                          <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                          Enviando...
                        </>
                      ) : (
                        'Contáctanos'
                      )}
                    </button>
                  </div>
                  <p className="form-messege mb-0 mt-20" />
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;